import React from "react";
import CodeExample from "../partials/content/CodeExample";
import { Table } from "react-bootstrap";
import { Bounce } from 'react-activity'
import {getSalesInsight, getOrders,getMyAccounts,getMaster,getOrderStatusSummary,getAccountDetails,getMyProfile,getOrderStatus } from "../crud/auth.crud";
import {
  Portlet,
  PortletBody,
//  PortletHeader,
//  PortletHeaderToolbar
} from "../partials/content/Portlet";
 import { Link } from "react-router-dom";
//import GaugeChart from 'react-gauge-chart'
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';
import {  format } from 'date-fns'

import Grid from '@material-ui/core/Grid';					
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Chip from '@material-ui/core/Chip';
import Alert from '@material-ui/lab/Alert'

import CircularProgress from '@material-ui/core/CircularProgress';

import { Bar,Line } from 'react-chartjs-2';
import { fill } from "lodash";




const data = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
    {
      label: 'Sales',
      data: [65, 59, 80, 81, 56, 55, 40],
      backgroundColor: 'rgba(255, 99, 132, 0.2)',
      borderColor: 'rgba(255, 99, 132, 1)',
      borderWidth: 1,
    },
  ],
};

const options = {
  tooltips: {
    callbacks: {
      label: (tooltipItem, data) => {
        const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
        const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        return `${datasetLabel}: $${value}`; // Prefix with $
      },
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};
const yearOptions = {
  legend: {
        display: false
    },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};

const userOptions = {
  
  scales: {
    yAxes: [
     
    ],
  },
};

export default class StatusTiles extends React.Component {
  state = {
    mStatus:[],
    schedules:[],
    widgetData:[],
    summary:[],
    account:{},
    isReset:false,
    filter:false,
    isLoading:false,
    entity:[],
    accounts:[],
    businessEntity:'',
    selaccount:null,
    summaryOld:[],
    latestOrders:[],
    isOrderStatusLoading:false,
    isLatestOrderLoading:false,
    isSalesYearLoading:false,
    isSalesMonthLoading:false,
    salesYear: null,
    salesMonth:null,
    salesUsers:null,

  }

  constructor(props)
{
	super(props);
	this.handleChangeEntity = this.handleChangeEntity.bind(this);
  this.handleChangeAccount = this.handleChangeAccount.bind(this);
   this.chartReference = React.createRef();
}

  handleFilter(event)
	{

    if(this.state.selaccount!==null && this.state.selaccount!=="")
    {
      this.setState({isLoading:true})
      getOrderStatusSummary(this.state.selaccount).then(response => response.data)
      .then((data) => {
        this.setState({ summary: data,isLoading:false });
        console.log("summary:::",data);
        //console.log(this.state.schedules);
      })
    }

  }


   handleReset(event)
  {
    this.setState({ summary: this.state.summaryOld, isReset:false,selaccount:"",businessEntity:""});
		 	
  }


  async componentDidMount()
  {

    this.setState({isOrderStatusLoading:true});
    this.setState({isLatestOrderLoading:true});
     this.setState({isSalesMonthLoading:true});
      this.setState({isSalesYearLoading:true});

    let widgetData=[];
    widgetData.push({accountKey:"ACC00044",user:12,storage:1,userPercentage:40,storagePercentage:10});
     widgetData.push({accountKey:"ACC00045",user:10,storage:2,userPercentage:30,storagePercentage:20});
      widgetData.push({accountKey:"ACC00046",user:8,storage:3,userPercentage:28,storagePercentage:30});
       widgetData.push({accountKey:"ACC00047",user:20,storage:8,userPercentage:60,storagePercentage:80});
    this.setState({widgetData:widgetData});
    
    await getMaster('entity')
							.then((response)=>
								{
									//console.log('Master :',fieldMap.fieldName);
									//alert(fieldMap.fieldName);
									this.setState({entity:response.data});
								


								})

                await getMyAccounts().then((response)=>{
                  this.setState({accounts:response.data});
                })
     
    getOrderStatusSummary().then(response => response.data)
    .then((data) => {
      this.setState({ summary: data,summaryOld:data,isOrderStatusLoading:false });
      console.log("summary:::",data);
      //console.log(this.state.schedules);
     })
    getOrderStatus().then(response => response.data)
    .then((data) => {
      this.setState({ mStatus: data })
      console.log("status:::",data);
     });

    getAccountDetails().then(response => response.data)
    .then((data) => {
      this.setState({ account: data })
      console.log("account:::",data);
     });
 
    getMyProfile().then(response => response.data)
    .then((data) => {
      

     })

     let postObj={};
      getOrders(1,postObj,5)//.then(response => response.data)
      .then((response) => {
         this.setState({latestOrders:response.data,isLatestOrderLoading:false});
      })

      let salesmonthparams = { "cdnintyear": new Date().getFullYear()};
       
       getSalesInsight("month",'default',salesmonthparams)//.then(response => response.data)
          .then((response) => {
            
            //this.setState({ tableData: response.data})
            console.log("salesby month::::",response.data);
            let labels = [];
            let data = [];
            response.data.map((ct)=>{
              labels.push(ct.month);
              data.push(ct.total.toFixed(2));
            })

             let salesmonthdata = {
            labels: labels,
            datasets: [
              {
                label: 'Sales',
                data: data,
                backgroundColor: "#de6e56",
                borderColor: "#de6e56",
                borderWidth: 0,
              },
              ],
            };
            this.setState({isSalesMonthLoading:false,salesMonth:salesmonthdata});
           
           })

           let salesyearparams = {};
       
       getSalesInsight("year",'default',salesyearparams)//.then(response => response.data)
          .then((response) => {
            
            //this.setState({ tableData: response.data})
            console.log("salesby month::::",response.data);
            let labels = [];
            let data = [];
            response.data.map((ct)=>{
              labels.push(ct.year);
              data.push(ct.total);
            })

             let salesyeardata = {
            labels: labels,
            datasets: [
              {
                label: 'Sales',
                data: data,
                backgroundColor: '#63bff0',
                borderColor: '#63bff0',
                borderWidth: 1,
              },
              ],
            };

             let salesyrdata = {
            labels: ['Min Stock', 'Total Stock','Max Stock'],
            datasets: [
              {
               // label: ['Min Stock', 'Total Stock','Max Stock'],
                data: [20,198,40],
                backgroundColor: ["#f7611b","#75f71b","#f7f41b"],
                fill:false,
                borderWidth: 0,
              }
              
              ],
            };


            this.setState({isSalesYearLoading:false,salesYear:salesyrdata});
           
           })

           let salesuserdata = {
            labels: ['Jan', 'Feb','Mar','Apr','May'],
            datasets: [
              {
                label: '2024',
                data: [12,43,22,4,5],
                backgroundColor: "#fd7f6f",
                borderColor: "#fd7f6f",
                fill:false,
                borderWidth: 0,
              },
              {
                label: '2025',
                data: [34,10,24,11,23],
                backgroundColor: "#7eb0d5",
                borderColor: "#7eb0d5",
                fill:false,
                borderWidth: 0,
              }
              
              ],
            };

            this.setState({salesUsers:salesuserdata});
      
    
  }
  handleChangeEntity(event)
  {
    //console.log(event);
    this.setState({businessEntity:event.target.value});
  }

  handleChangeAccount(event)
  {
    //console.log(event);
    this.setState({selaccount:event.target.value});
    
  }
  
  
  render() {
    return (
      <>

        <div className="row">
          <div className="col-xl-12">
              <CodeExample jsCode="true" beforeCodeTitle="Filter">
                <div className="kt-section" >
                  <Grid container spacing={3}>
                  
                    <Grid item xs={12} sm={6}>
                      <TextField  style={{'width':'100%'}} name="businessEntity" 
                          id="businessEntity"  label="Account Type"
                          onChange={this.handleChangeEntity}
                          value={this.state.businessEntity}
                            select>
                              
                          <MenuItem value="">Select</MenuItem>
                          { 
                          this.state.entity.length>0 && this.state.entity.map((ent) => (
                            
                            <MenuItem key={ent.businessEntity} value={ent.businessEntity}>{ent.businessEntity}</MenuItem>
                              
                          ))
                          }
                         
                      </TextField>

                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField  style={{'width':'100%'}} name="accountKey" 
                          id="accountKey"  label="Account"
                          onChange={this.handleChangeAccount}
                            select>
                         
                          { 
                          this.state.accounts.length>0 && this.state.accounts.filter(x=>x.businessEntity===this.state.businessEntity).length>0 && this.state.accounts.filter(x=>x.businessEntity===this.state.businessEntity).map((acc) => (
                            
                            <MenuItem key={acc.accountId} value={acc.accountId}>{acc.accountName}</MenuItem>
                              
                          ))
                          }
                          {
                            this.state.accounts.filter(x=>x.businessEntity===this.state.businessEntity).length===0 &&
                              <MenuItem value="">None</MenuItem>
                          }
                      </TextField>

                    </Grid>
                  </Grid>
                </div>
            
            <div>
            <Button
          variant="outlined"
          color="primary"
          onClick={this.handleFilter.bind(this)}
          endIcon={<Icon>search</Icon>}
          style={{'padding':'10px','margin':'10px'}}
          >
          {
            this.state.isLoading==true&&<><Bounce /></>
          }
          {
            this.state.isLoading==false&&<>Apply Filter</>
          }
          </Button>
          
          <Button
          variant="outlined"
          color="primary"
          onClick={this.handleReset.bind(this)}
          endIcon={<Icon>backspace</Icon>}
          style={{'padding':'10px','margin':'10px'}}
          >
          {
            this.state.isReset==true&&<><Bounce /></>
          }
          {
            this.state.isReset==false&&<>Reset Filter</>
          }
          </Button>
          </div>

              </CodeExample>
          </div>
          <div className="col-xl-12">
           <div className="row">
        
              <div className="col-lg-12">
                 <div className="row">
                 {this.state.mStatus.map((status,index) => (
                               <div className="col-lg-3" key={"a"+index}>
                                <Link to={{pathname:"/orders", data: {orderStatusKey:status.orderStatusId,accountKey:this.state.selaccount}}}>
                                  <Portlet className="kt-portlet--border-bottom-brand" >
                                    <PortletBody fluid={true}>
                                      
                                        <div className="kt-widget26">
                                        <div className="kt-widget26__content">
                                          <span className="kt-widget26__number" style={{'color':status.orderStatusColor}}> 
                                            {this.state.summary.filter(s=> s.statusId==status.orderStatusId).map((sum)=>(
                                              sum.count
                                            ))}
                                            
                                          </span>
                                          <span className="kt-widget26__desc" style={{'color':status.orderStatusColor}}> {status.orderStatusName}</span>
                                        </div>
                                        </div>
                                      
                                    </PortletBody>
                                  </Portlet>
                                  </Link>
                                 </div>
                                ))}
               
                    {this.state.isOrderStatusLoading &&
                            <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                                <Alert severity="info" icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Loading...</Alert>      
                            </div>
                      }
                     

                    {/*this.state.mStatus !==null && this.state.mStatus.length>0 && 
                    <div className="kt-widget4">
                       {this.state.mStatus.map((status,index) => (
                        
                      <div className="kt-widget4__item ">
                        
                        <div className="kt-widget4__info ">
                          <a
                            className="kt-widget4__username"
                            href="#" style={{'color':status.orderStatusColor}}
                          >
                            {status.orderStatusName}
                          </a>
                          
                        </div>
                        <Link to={{pathname:"/orders", data: {statusKey:status.orderStatusId,accountId:this.state.selaccount}}}>
                        <a className="btn btn-sm btn-label-dark" style={{'color':status.orderStatusColor, fontSize:12}}>
                           {this.state.summary.filter(s=> s.statusId==status.orderStatusId).map((sum)=>(
                              sum.count
                            ))}
                        </a>
                        </Link>
                      </div>
                      
                      ))}
                    </div>
                    */}


                     </div>
                      
                   
                  
                
              </div>
              <div className="col-lg-12">
                <div className="kt-portlet kt-portlet--height-fluid">
                        <div className="kt-portlet__head">
                          <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">Latest 5 Orders</h3>
                          </div>
                          
                        </div>
                       
                        <div className="kt-portlet__body">
                        {this.state.latestOrders!==null && this.state.latestOrders.length>0 &&
                          <div className="kt-widget1">
                             { this.state.latestOrders.map((order,index) => (

                               
                                <div className="kt-widget1__item ng-star-inserted" key={'lt'+index}>
                                  <Link to={{pathname:"/orders", data: {orderKey:order.orderKey}}}>
                                  <div className="kt-widget1__info">
                                    <h3 className="kt-widget1__title">{order.accountName }</h3>
                                    <span className="kt-widget1__desc">{order.requestedBy + ', '+format(new Date(order.createdOn), 'MM/dd/yyyy')}</span>
                                  </div>
                                  </Link>
                                  <span className="kt-widget1__number kt-font-brand">
                                    
                                      {<Chip label={order.orderStatus.orderStatusName} style={{backgroundColor:order.orderStatus.orderStatusColor,color:'white'}}/>}
                                    
                                    </span>
                                </div>
                             
                            
                             ))}
                          </div>
                        }
                        {this.state.isLatestOrderLoading &&
                            <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                                <Alert severity="info" icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Loading...</Alert>      
                            </div>
                         }
                      </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                
                 <div className="kt-portlet kt-portlet--height-fluid">
                  <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                      <h3 className="kt-portlet__head-title">Sales By Month</h3>
                    </div>
                   
                  </div>
                  <div className="kt-portlet__body">
                    {this.state.salesMonth!==null &&
                      <Bar  ref={this.chartReference}  data={this.state.salesMonth} options={options} />
                    }
                    
                {this.state.isSalesMonthLoading &&
                            <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                                <Alert severity="info" icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Loading...</Alert>      
                            </div>
                      }
                  </div>
                </div>
                
              </div>
              
             {<div className="col-lg-6">
               
                 <div className="kt-portlet kt-portlet--height-fluid">
                  <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                      <h3 className="kt-portlet__head-title">Stock Status</h3>
                    </div>
                   
                  </div>
                  <div className="kt-portlet__body">
                    {this.state.salesYear!==null &&
                      <Bar ref={this.chartReference}  data={this.state.salesYear} options={yearOptions} />
                    }
                    {this.state.isSalesYearLoading &&
                            <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                                <Alert severity="info" icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Loading...</Alert>      
                            </div>
                      }
                  </div>
                </div>
                
                
              </div>}
             
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="kt-portlet kt-portlet--height-fluid">
                  <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                      <h3 className="kt-portlet__head-title">Sales Comparison</h3>
                    </div>
                   
                  </div>
                  <div className="kt-portlet__body">
                    {this.state.salesUsers!==null &&
                      <Line  ref={this.chartReference}  data={this.state.salesUsers} options={userOptions} />
                    }
                    
               
                  </div>
                </div>
              </div>
            </div>
        </div>
       </div>
      </>
    );
  }
}
